<template>
  <div class="sys-container">
    <h2>全部导航</h2>
    <div>
      <el-input
        placeholder="请输入系统名称"
        prefix-icon="el-icon-search"
        v-model="keyword"
        clearable
        @input="search()"
      ></el-input>
    </div>
    <div class="tips" v-if="showTotal">
      为您匹配到
      <span class="num">{{total}}</span> 个结果
    </div>
    <ul class="sys-list">
      <li v-for="(item,index) in systemList" :key="index" class="sys-chunk">
        <h3>{{item.name}}</h3>
        <ul class="item-list">
          <div
            v-for="(i,ind) in item.list"
            :key="ind"
            class="sys-item"
            target="_blank"
            :style="{backgroundColor:i.mark?'#f8f8f8':''}"
            @click="toUrl(i)"
          >
            <div class="info">
              {{i.title}}
              <img src="@/assets/icon/icon-system-new.png" v-if="i.new" />
              <div class="redDot" v-if="!i.new&&i.show_update"></div>
            </div>
            <div>
              <img
                style="cursor: pointer;"
                src="@/assets/icon/icon-system-add2.png"
                v-if="i.mark"
                @click="delMysystem(i.key,index,ind)"
              />
              <img
                class="collection"
                src="@/assets/icon/icon-system-add1.png"
                v-else
                @click="addMysystem(i.key,index,ind)"
              />
            </div>
          </div>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "all-system",
  props: {
    dialogVisbility: Boolean
  },
  data() {
    return {
      visbility: this.dialogVisbility,
      systemList: "",
      markList: "",
      keyword: "",
      total: 0,
      showTotal: false
    };
  },
  created() {
    this.dealWithData();
  },
  watch: {
    mySystem() {
      this.dealWithData();
    },
    keyword(val) {
      if (val == "") {
        this.showTotal = false;
      } else {
        this.showTotal = true;
      }
    }
  },

  computed: {
    ...mapGetters(["mySystem"])
  },
  methods: {
    search: _.debounce(function() {
      this.dealWithData();
    }, 500),
    toUrl(system) {
      if (system.show_update) {
        let routeUrl = this.$router.resolve({
          path: "link",
          query: {
            url: system.url,
            key: system.key,
            date: system.c_t,
            name: system.title
          }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        window.open(system.url);
      }
    },
    async dealWithData(data) {
      let allListRes = await _api.home.getList({ keyword: this.keyword });
      this.systemList = this.arrToObj(allListRes.data);
      let markList = new Set();
      this.mySystem.forEach(item => {
        markList.add(item.key);
      });
      markList = [...markList];

      let c = [];
      let d = {};
      this.total = 0;
      this.systemList.forEach(element => {
        this.total += Number(element.list.length);
        element.list.forEach(i => {
          if (markList.indexOf(i.key) != -1) {
            i.mark = 1;
          }
          if (i.c_t * 1000 > new Date().getTime() - 5 * 24 * 3600 * 1000) {
            i.new = true;
          }
          if (!d[i.group_name]) {
            c.push({
              type: i.group_name,
              allData: [i]
            });
            d[i.group_name] = i;
          } else {
            c.forEach(ele => {
              if (ele.group_name == i.group_name) {
                ele.allData.push(i);
              }
            });
          }
        });
      });
    },
    sortNumber(a, b) {
      return a.sort - b.sort;
    },
    addMysystem(key, index, ind) {
      event.stopPropagation();
      event.preventDefault();
      if (this.mySystem.length > 15) {
        this.$message(`【常用系统】添加已达上限`);
        return;
      }
      let item = this.systemList[index].list[ind];
      item.mark = true;
      this.systemList[index].list.splice(ind, 1, item);
      this.$message(`已添加至【常用系统】${this.mySystem.length + 1}/16`);

      let save_data = this.mySystem.map(i => {
        let a = {};
        a.key = i.key;
        a.sort = i.sort;
        return a;
      });
      let addItem = {
        key,
        sort: save_data.length + 1
      };
      save_data.push(addItem);
      _api.home.saveSystem({ save_data }).then(res => {
        this.$store.dispatch("getSystem").then(res => {
          this.dealWithData();
        });
      });
    },
    delMysystem(keys, index, ind) {
      let item = this.systemList[index].list[ind];
      item.mark = false;
      this.systemList[index].list.splice(ind, 1, item);
      this.$message("已从常用系统中移除");
      event.stopPropagation();
      event.preventDefault();
      _api.home.delSystem({ keys }).then(res => {
        this.$store.dispatch("getSystem").then(res => {
          this.dealWithData();
        });
      });
    },
    arrToObj(data) {
      let a = Object.keys(data);
      let obj = a.map(i => {
        let item = {};
        item.name = i;
        item.list = data[i];
        return item;
      });
      return obj;
    }
  }
};
</script>

<style lang="scss" scoped>
.sys-container {
  overflow-y: auto;
  padding: 30px 10px 30px 20px;
  color: #333;
  line-height: 36px;
  h2 {
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 20px;
  }

  /deep/.el-input {
    width: 570px;
  }
  /deep/.el-input__inner {
    height: 36px;
  }
  .tips {
    font-size: 14px;
    margin-top: 6px;
    height: 18px;
    line-height: 18px;
    .num {
      color: #1890ff;
    }
  }
}
.sys-list {
  padding: 20px 0;
  column-count: 4;
}
.sys-chunk {
  text-align: left;
  color: #333;
  background-color: #fff;
  width: 270px;
  padding: 20px 10px;
  margin: 0;
  break-inside: avoid;
  margin-bottom: 20px;
  font-size: 14px;
  h3 {
    font-size: 18px;
    font-weight: 600;
    padding-left: 10px;
    margin-bottom: 16px;
    line-height: 18px;
  }
}

.sys-item {
  width: 246px;
  margin: 2px 0;
  height: 28px;
  padding: 0 10px;
  line-height: 28px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background-color: #f8f8f8;
  }
  &:hover .collection {
    display: inline-block;
  }
  .info {
    display: flex;
    align-items: center;
    .redDot {
      width: 8px;
      height: 8px;
      background-color: rgba(255, 59, 48, 1);
      border-radius: 4px;
      margin: 0 5px;
    }
  }

  .collection {
    cursor: pointer;
    display: none;
  }
}
</style>
<style lang="scss">
</style>
